var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0802279 0.492255C0.221742 0.192065 0.527411 0 0.863647 0H18.1364C18.4726 0 18.7783 0.192065 18.9198 0.492255C19.0613 0.792444 19.0129 1.14618 18.7958 1.39887L12.0909 9.20222V16.15C12.0909 16.4446 11.9359 16.7182 11.6813 16.8731C11.4267 17.0279 11.1088 17.042 10.841 16.9103L7.3865 15.2103C7.09391 15.0663 6.90909 14.772 6.90909 14.45V9.20222L0.204201 1.39887C-0.0129149 1.14618 -0.0612859 0.792444 0.0802279 0.492255ZM2.72504 1.7L8.43217 8.34213C8.56402 8.49558 8.63636 8.69004 8.63636 8.891V13.9247L10.3636 14.7747V8.891C10.3636 8.69004 10.436 8.49558 10.5678 8.34213L16.275 1.7H2.72504Z",
    fill: "#5FFFA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.6bea29433eb3fb57a50492224a622048.svg";
export { ForwardRef as ReactComponent };